export const policiesType = ["Primary", "Secondary"];
